import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=9bec0d2a&scoped=true&"
import script from "./MemberCenter.vue?vue&type=script&lang=js&"
export * from "./MemberCenter.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenter.vue?vue&type=style&index=0&id=9bec0d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bec0d2a",
  null
  
)

export default component.exports